import { EnquiryTypes as ActionConstant } from "../Actions/Types/Enquiry";
const initState = {
	errors: [],
	PROCESSING: false,
	REQUEST_SUCCESS: false,
	REQUEST_FAILED: false,
	message: "",
	contactData: [],
	franchiseData: [],
	feedbackData: [],
};

const EnquirydReducer = (state = initState, action) => {
	state = {
		...state,
		errors: [],
		message: "",
		PROCESSING: false,
		REQUEST_SUCCESS: false,
		REQUEST_FAILED: false,
	};
	switch (action.type) {
		case ActionConstant.GET_FRANCHISE_DETAILS:
			state = {
				...state,
				PROCESSING: true,
				REQUEST_SUCCESS: false,
				REQUEST_FAILED: false,
			};
			break;

		case ActionConstant.GET_FRANCHISE_DETAILS_SUCCESS:
			console.log("Contact Us Data:", action);
			state = {
				...state,
				franchiseData: action.payload.data,
				PROCESSING: false,
				REQUEST_SUCCESS: true,
			};
			break;

		case ActionConstant.GET_CONTACT_US_DETAILS:
			state = {
				...state,
				PROCESSING: true,
				REQUEST_SUCCESS: false,
				REQUEST_FAILED: false,
			};
			break;

		case ActionConstant.GET_CONTACT_US_DETAILS_SUCCESS:
			console.log("Contact Us Data:", action);
			state = {
				...state,
				contactData: action.payload.data,
				PROCESSING: false,
				REQUEST_SUCCESS: true,
			};
			break;

		case ActionConstant.CREATE_FRANCHISE_ENQUIRY:
			state = {
				...state,
				PROCESSING: true,
				REQUEST_SUCCESS: false,
				REQUEST_FAILED: false,
			};
			break;

		case ActionConstant.CREATE_FRANCHISE_ENQUIRY_SUCCESS:
			state = {
				...state,
				PROCESSING: false,
				REQUEST_SUCCESS: true,
				message: action.payload.message,
			};
			break;

		case ActionConstant.CREATE_CONTACT_US:
			state = {
				...state,
				PROCESSING: true,
				REQUEST_SUCCESS: false,
				REQUEST_FAILED: false,
			};
			break;

		case ActionConstant.CREATE_CONTACT_US_SUCCESS:
			state = {
				...state,
				PROCESSING: false,
				REQUEST_SUCCESS: true,
				message: action.payload.message,
			};
			break;

		case ActionConstant.CREATE_FEEDBACK:
			state = {
				...state,
				PROCESSING: true,
				REQUEST_SUCCESS: false,
				REQUEST_FAILED: false,
			};
			break;

		case ActionConstant.CREATE_FEEDBACK_SUCCESS:
			console.log("Feedback Data:", action.payload);
			state = {
				...state,
				PROCESSING: false,
				REQUEST_SUCCESS: true,
				message: action.payload.message,
			};
			break;

		case ActionConstant.GET_FEEDBACKS:
			state = {
				...state,
				PROCESSING: true,
				REQUEST_SUCCESS: false,
				REQUEST_FAILED: false,
			};
			break;

		case ActionConstant.GET_FEEDBACKS_SUCCESS:
			state = {
				...state,
				feedbackData: action.payload.data,
				PROCESSING: false,
				REQUEST_SUCCESS: true,
			};
			break;

		case ActionConstant.ENQUIRE_ERROR:
			state = {
				...state,
				message: action.payload.message,
				errors: action.payload.errors,
				REQUEST_FAILED: true,
			};
			break;
		default:
			return state;
	}
	return state;
};

export default EnquirydReducer;
